module.exports = function (context) {
  return function (selection) {
    const Buildings3D = [
      {
        label: 'Show',
        value: true
      },
      {
        label: 'Hide',
        value: false
      }
    ];

    const container3D = selection
      .append('div')
      .attr(
        'class',
        'toggle-3D absolute left-0 bottom-0 mb-16 text-xs transition-all duration-200 z-10'
      );

    container3D
      .append('span')
      .attr('class', 'bg-white p-[4px]')
      .text('3D Buildings');

    const buttons3D = container3D.selectAll('button').data(Buildings3D);

    // D3 v3 event handler: receives (d, i), `this` is the DOM element, event via d3.event
    const set3DBuildings = function (d) {
      const clicked = this;

      buttons3D.classed('active', function () {
        return clicked === this;
      });

      // Check if map is initialized and loaded (context.map becomes the map instance after initialization)
      const mapInstance = context.map;
      if (mapInstance && typeof mapInstance.getLayer === 'function') {
        const { value } = d;

        // Trimble Maps 3D buildings handling
        // Try to find and toggle 3D building layers
        try {
          const buildingLayers = [
            'building-extrusion',
            '3d-buildings',
            'building'
          ];
          buildingLayers.forEach((layerId) => {
            if (mapInstance.getLayer(layerId)) {
              mapInstance.setLayoutProperty(
                layerId,
                'visibility',
                value ? 'visible' : 'none'
              );
            }
          });
        } catch (e) {
          console.log(
            '3D buildings layer not found or not supported in current style'
          );
        }

        context.storage.set('3DBuildings', value);
      }
    };

    buttons3D
      .enter()
      .append('button')
      .attr('class', 'pad0x')
      .on('click', set3DBuildings)
      .text((d) => {
        return d.label;
      });
  };
};
